const DEFAULT_FILL = '#2962ff0d'

function finiteNumber(value) {
  return typeof value === 'number' && Number.isFinite(value)
}

function resolveBandPoints({ points, chart, series, horizontalPixelRatio, verticalPixelRatio }) {
  const upper = []
  const lower = []
  const timeScale = chart.timeScale()

  for (const point of points) {
    if (
      !finiteNumber(point?.time) ||
      !finiteNumber(point?.upper) ||
      !finiteNumber(point?.lower)
    ) continue
    const xLogical = timeScale.timeToCoordinate(point.time)
    if (xLogical == null) continue
    const upperY = series.priceToCoordinate(point.upper)
    const lowerY = series.priceToCoordinate(point.lower)
    if (upperY == null || lowerY == null) continue
    upper.push({
      x: xLogical * horizontalPixelRatio,
      y: upperY * verticalPixelRatio,
    })
    lower.push({
      x: xLogical * horizontalPixelRatio,
      y: lowerY * verticalPixelRatio,
    })
  }

  return { upper, lower }
}

export class BandFillPrimitive {
  constructor() {
    this.__isBandFillPrimitive = true
    this._data = { points: [], fillStyle: DEFAULT_FILL }
    this._chart = null
    this._series = null
    this._requestUpdate = null
    this._paneViews = [new BandFillPaneView(this)]
  }

  attached(param) {
    this._chart = param.chart
    this._series = param.series
    this._requestUpdate = param.requestUpdate
  }

  detached() {
    this._chart = null
    this._series = null
    this._requestUpdate = null
    this._data = { points: [], fillStyle: DEFAULT_FILL }
  }

  update(next) {
    this._data = {
      points: Array.isArray(next?.points) ? next.points : this._data.points,
      fillStyle: next?.fillStyle || this._data.fillStyle || DEFAULT_FILL,
    }
    if (typeof this._requestUpdate === 'function') this._requestUpdate()
  }

  updateAllViews() { /* renderer reads live state */ }

  paneViews() {
    return this._paneViews
  }
}

class BandFillPaneView {
  constructor(primitive) {
    this._renderer = new BandFillPaneRenderer(primitive)
  }

  zOrder() { return 'bottom' }

  renderer() { return this._renderer }
}

class BandFillPaneRenderer {
  constructor(primitive) {
    this._primitive = primitive
  }

  draw() { /* background renderer only */ }

  drawBackground(target) {
    const data = this._primitive._data
    const chart = this._primitive._chart
    const series = this._primitive._series
    if (!data?.points?.length || !chart || !series) return

    target.useBitmapCoordinateSpace((scope) => {
      const { upper, lower } = resolveBandPoints({
        points: data.points,
        chart,
        series,
        horizontalPixelRatio: scope.horizontalPixelRatio || 1,
        verticalPixelRatio: scope.verticalPixelRatio || 1,
      })
      if (upper.length < 2 || lower.length < 2) return

      const ctx = scope.context
      ctx.save()
      ctx.fillStyle = data.fillStyle
      ctx.beginPath()
      ctx.moveTo(upper[0].x, upper[0].y)
      for (let i = 1; i < upper.length; i++) {
        ctx.lineTo(upper[i].x, upper[i].y)
      }
      for (let i = lower.length - 1; i >= 0; i--) {
        ctx.lineTo(lower[i].x, lower[i].y)
      }
      ctx.closePath()
      ctx.fill()
      ctx.restore()
    })
  }
}
